import React from "react";
import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";
import Section from "@/components/Section";
import { Link } from "react-router-dom";
import { ArrowLeft, Compass } from "lucide-react";

export default function NotFoundPage() {
  return (
    <>
      <PublicNav />
      <div className="relative overflow-hidden dt6-flag-wave">
        <Section className="pt-32 pb-32 text-center relative" testId="not-found">
          {/* Ghosted DT6 watermark — reserves the drama for the seal without repeating it */}
          <div
            aria-hidden
            className="absolute inset-0 flex items-center justify-center pointer-events-none select-none"
            style={{ opacity: 0.04 }}
          >
            <div className="font-heading font-black" style={{ fontSize: "38rem", lineHeight: 1, color: "var(--dt6-text)" }}>
              404
            </div>
          </div>

          <div className="relative dt6-fade-in">
            <div className="dt6-chip dt6-chip-primary inline-flex" data-testid="not-found-eyebrow">
              / PROTOCOL 404 · TERRITORY UNCHARTED
            </div>
            <h1 className="mt-6 font-heading text-6xl md:text-7xl font-black leading-tight">
              Off the map.<br />
              <span style={{ color: "var(--dt6-primary)" }}>Not off the mission.</span>
            </h1>
            <p className="mt-6 text-[color:var(--dt6-muted)] max-w-xl mx-auto">
              The page you requested is not on the manifest.  It may have been retired, renamed, or was never charted.
            </p>
            <div className="mt-10 flex flex-wrap justify-center gap-3">
              <Link to="/" className="dt6-btn dt6-btn-primary" data-testid="not-found-back-to-base">
                <ArrowLeft size={14} /> Back to base
              </Link>
              <Link to="/standard" className="dt6-btn" data-testid="not-found-standard-link">
                <Compass size={14} /> Read The Standard
              </Link>
            </div>
          </div>
        </Section>
      </div>
      <PublicFooter />
    </>
  );
}
